import { Contracts, ContractNames } from "@airdao/bond-periphery/core";
import { AddressLike, BigNumberish } from "ethers";
import { TimeFrameOracle } from "@airdao/bond-periphery/core/contracts/types";

type TimeFrame = {
  startTime: BigNumberish;
  endTime: BigNumberish;
};

export async function SetWriter(contracts: Contracts, contractName: ContractNames = ContractNames.TimeFrameOracle, writer: AddressLike) {
  const oracle = contracts.getContractByName(contractName) as unknown as TimeFrameOracle;
  return await oracle.setWriter(writer);
}

export async function SetFrame(contracts: Contracts, contractName: ContractNames = ContractNames.TimeFrameOracle, frame: TimeFrame) {
  const oracle = contracts.getContractByName(contractName) as unknown as TimeFrameOracle;
  return await oracle.setFrame(frame);
}

export async function ResetFrame(contracts: Contracts, contractName: ContractNames = ContractNames.TimeFrameOracle) {
  const oracle = contracts.getContractByName(contractName) as unknown as TimeFrameOracle;
  return await oracle.reset();
}

export const AdminMethods = {
  SetFrame,
  ResetFrame,
  SetWriter,
};

export default AdminMethods;